<div class="login-notification-backdrop" *ngIf="isVisible$ | async" (click)="closeModal()">
  <div class="login-notification-container" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
    <button class="close-button" type="button" (click)="closeModal()" aria-label="Close">
      <span class="material-icons">close</span>
    </button>

    <div class="login-notification-content">
      <div class="notification-icon" aria-hidden="true">
        <span class="material-symbols-outlined">campaign</span>
      </div>
      <h2 class="notification-title">{{ t.title }}</h2>
      <p class="notification-message">{{ t.message }}</p>
      <button type="button" class="btn-ok" (click)="closeModal()">{{ t.close }}</button>
    </div>
  </div>
</div>
